// extracted by mini-css-extract-plugin
module.exports = {"componentsSelectPaymentMethod":"styles_componentsSelectPaymentMethod__1bjPM","opText":"styles_opText__1SjAE"};